import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Breadcrumbs = ({ items }) => {
  const { t } = useTranslation('cy');
  const trail = [{ label: t('breadcrumb.home'), to: '/' }, ...items];

  return (
    <nav aria-label="Breadcrumb" className="cy-breadcrumbs" style={{ marginBottom: 24 }}>
      <ol style={{ listStyle: 'none', display: 'flex', flexWrap: 'wrap', gap: 8, margin: 0, padding: 0 }}>
        {trail.map((item, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--cy-color-text-secondary)' }}>
            {i > 0 && <span aria-hidden="true" style={{ color: 'var(--cy-color-border-input)' }}>/</span>}
            {item.to ? (
              <Link className="cy-link" to={item.to} style={{ textDecoration: 'none' }}>
                {item.label}
              </Link>
            ) : (
              <span aria-current="page">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
